import React from 'react'
import PropTypes from 'prop-types'

import { Cta } from '../../Cta'
import { useDropdownContext } from '../DropdownContext'

const MobileButton = ({ text }) => {
  const { toggle } = useDropdownContext()

  const onKeyDown = ({ key }) => {
    if (key === 'Enter') {
      toggle()
    }
  }

  return (
    <Cta
      text={text}
      buttonType="orangeOutline"
      onClick={toggle}
      onKeyDown={onKeyDown}
    />
  )
}

MobileButton.propTypes = {
  text: PropTypes.string.isRequired,
}

export default MobileButton
